import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { ModalProps } from '../modal.component';

@Component({
    selector: 'modal-body-wrapper',
    templateUrl: './modal-body-wrapper.component.html',
    styleUrls: ['./modal-body-wrapper.component.scss']
})
export class ModalBodyWrapperComponent implements OnInit {

    @Input() public bodyContent: ModalProps['bodyContent'];

    constructor() { }

    ngOnInit() { }

    isTemplateRef() {
        return this.bodyContent instanceof TemplateRef;
    }
}
